import React, { useState } from 'react';
import init from '../firebase';
import { linkWithCredential, RecaptchaVerifier, PhoneAuthProvider, getAuth } from 'firebase/auth';
import { getFirebaseErrorMessage } from './getFirebaseErrorMessage';
const LoginWithMobileNumber = () => {
  console.log('user..',init.auth.currentUser);
  const auth = init.auth
  const [phoneNumber, setPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [verificationId, setVerificationId] = useState('');

  const setUpRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
          'size': 'invisible',
          'callback': (response) => {
              
          },
          'expired-callback': () => {
          }
      }, auth);
  }
  };

  const sendVerificationCode = async () => {
    try {
      setUpRecaptcha();
      const appVerifier = window.recaptchaVerifier;
      const phoneProvider = new PhoneAuthProvider(auth);
      const verificationId = await phoneProvider.verifyPhoneNumber(phoneNumber, appVerifier);
      setVerificationId(verificationId);
      console.log('Verification code sent');
    } catch (error) {
      console.error('Error during verification code sending:', error);
    }
  };

  const linkWithPhoneNumber = () => {
    const credential = PhoneAuthProvider.credential(verificationId, verificationCode);
    // const auth = getAuth();
    linkWithCredential(auth.currentUser, credential)
      .then((usercred) => {
        const user = usercred.user;
        console.log("Account linking success", user);
      }).catch((error) => {
        const res = getFirebaseErrorMessage(error.code)
        alert(res)
        console.log(error)
        console.log("Account linking error", error);
      });
  };

  return (
    <div>
      <input
        type="text"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        placeholder="Enter Phone Number"
      />
      <button onClick={sendVerificationCode}>Send Verification Code</button>
      <input
        type="text"
        value={verificationCode}
        onChange={(e) => setVerificationCode(e.target.value)}
        placeholder="Enter Verification Code"
      />
      <button onClick={linkWithPhoneNumber}>Link Phone Number</button>
      <div id="recaptcha-container"></div>
    </div>
  );
};

export default LoginWithMobileNumber;
